export default __webpack_public_path__ + "static/media/Map.14ae2919.png";